import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AuthService } from 'src/app-core/auth/auth.service';

@Component({
    selector: 'app-session-logout-popup',
    templateUrl: './session-logout-popup.component.html',
    styleUrls: ['./session-logout-popup.component.scss'],
})
export class SessionLogoutPopupComponent implements OnInit {

    timerSubscription: Subscription;

    constructor(
        private dialogRef: MatDialogRef<SessionLogoutPopupComponent>,
        private elementRef: ElementRef,
        private authService: AuthService
    ) { }

    ngOnInit() {
        let callDuration = this.elementRef.nativeElement.querySelector('#time');
        this.startTimer(callDuration);
    }

    startTimer(display) {
        let timer = 300;
        let minutes;
        let seconds;

        this.timerSubscription = interval(1000).pipe(
            takeWhile(() => timer >= 0)
        ).subscribe(() => {
            minutes = Math.floor(timer / 60);
            seconds = Math.floor(timer % 60);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + " minutes " + seconds + " seconds";

            --timer;
            if (timer == 0) {
                this.dialogRef.close();
                this.authService.logout();
            }
        });
    }

    async onClose() {
        await this.authService.refreshToken();
        this.dialogRef.close();
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
}
